import styled from '@emotion/styled';

import { Link } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, lighten, IconButton } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import EditRoundedIcon from '@mui/icons-material/EditRounded';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';

import { BasicFlex, Notes } from '../../../utils/Common';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import { formatCurrency, formatPhoneNumber } from '../../../utils/util';

import useSimpleTable from '../../../hooks/useSimpleTable';
import SimplePagination from '../../../utils/utilities/SimplePagination';

import SearchInput from '../../../utils/utilities/SearchInput';

import NoTimeline from '../../../utils/utilities/Timeline/NoTimeline';

import TimelineWithComments from '../../../utils/utilities/Timeline/TimelineWithComments';

import { capitalize } from 'lodash';

// action buttons
import DownloadButton from '../../../utils/utilities/Buttons/DownloadButton';
import ShareButton from '../../../utils/utilities/Buttons/ShareButton';
import EmailButton from '../../../utils/utilities/Buttons/EmailButton';
import EditButton from '../../../utils/utilities/Buttons/EditButton';

import ShareCard from '../../../utils/utilities/Buttons/ShareCard';

const Balance = styled.div`
  font-size: 2.4rem;
  font-weight: 600;
`

const InventoryLineStyles = styled(BasicFlex)`
  border: 1px solid ${props => lighten(props.theme.colors.secondaryMid, .4)};
  border-radius: 3px;
  padding: 1rem;
  background-color: ${props => lighten(props.theme.colors.secondaryFaint, .9)};
`;

const PriceInfo = styled.div`
  font-weight: 500;
`

const SearchContainer = styled.div`
  /* margin: 1.5rem 0; */
  max-width: 90rem;
` 

const InventoryLine = ({ inventory = {}, index }) => {
  return (
    <InventoryLineStyles>

    <BasicFlex justify="flex-start" gap="5rem">
      <span>{inventory.wig_id}</span>
      <span>{<SimpleChip label={inventory.sku} />}</span>
    </BasicFlex>

    <PriceInfo>{formatCurrency(inventory.cost_total)}</PriceInfo>
    </InventoryLineStyles>
  )
}

const GeneralTab = () => {
  const { data = {} } = usePageData();

  const detailsBlock = [
    {header: "Vendor", icon: <AccountBoxOutlinedIcon fontSize='small' />, info: data.vendor_name},
    {header: "Email", icon: <EmailOutlinedIcon fontSize='small' />, info: data.vendor_email},
    {header: "Mobile", icon: <PhoneOutlinedIcon fontSize='small' />, info: data.vendor_phone, dataType: "phone"},
  ];

  let shipment_type = <MultiStatusChip value={data.shipment_type} values={[{value: "inbound", label: "Consignment", status: "success"}, {value: "outbound", label: "Return", status: "warning"}]} />;

  const shipmentBlock = [
    {header: "Shipment Number", info: `#${data.shipment_num}`, dataType: "string"},
    {header: "Shipment Type", info: shipment_type},
    {header: "Total Items", info: data.total_qty, dataType: "number"},
  ]

  const activityBlock = [
    {header: "Shipment Date", info: data.date_created, dataType: "shortDate"},
    {header: "Date Created", info: data.created_at, dataType: "dateTime"},
    {header: "Created", info: capitalize(data.generated)}
  ];


  const { data: wigs, pagination, setPagination, setSearchTerm } = useSimpleTable({localData: data.wigs, searchFields: ["wig_id", "sku"], defaultSort: "wig_id"});

  console.log(wigs, "wigs");
  

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 8}}>
        <Card variant='outlined'>
          <CardHeader title="Basic Details" subheader={`#${data.shipment_num}`}
            action={<BasicFlex gap=".5rem">
              <EditButton href={`/shipments/edit/${data.shipment_id}`} title="Edit Shipment" />
            </BasicFlex>}
          />
          <CardContent>
            <CardBlockContainer>
              <CardBlockHeader>Vendor Information</CardBlockHeader>
              {detailsBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Shipment Details</CardBlockHeader>
              {shipmentBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Activity</CardBlockHeader>
              {activityBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Notes</CardBlockHeader>
              <Notes>{data.notes}</Notes>
        
            </CardBlockContainer>
          </CardContent>
        </Card>

        <Card variant='outlined' sx={{mt: "2rem"}}>
          <CardHeader title={`Shipment Items (${data.total_qty})`} />
          <CardContent>
            <SearchContainer>
              <SearchInput onChange={(e) => setSearchTerm(e.target.value)} />
            </SearchContainer>
            <BasicFlex dir="column" gap=".8rem" my="1.5rem">
            {wigs?.rows?.map((inventory, index) => <InventoryLine key={index} inventory={inventory} index={index} />)}
            </BasicFlex>
            <SimplePagination 
              rowsPerPage={pagination?.rowsPerPage} 
              currentPage={pagination?.page} 
              setPagination={setPagination} 
              resultCount={wigs?.pages} 
              results={wigs?.rows} 
            />
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 4}}>
        <BasicFlex dir="column" gap="2rem">
          <ShareCard url={`/shipments/generate/${data.shipment_id}`} defaultEmail={data.vendor_email} />
          <Card variant='outlined' sx={{width: "100%"}}>
            <CardHeader title="Timeline" />
            <CardContent>
              <TimelineWithComments resource="shipment" resource_id={data.shipment_id} expand={true} />
            </CardContent>
          </Card>
        </BasicFlex>
      </Grid>

    </Grid>
  );

};

export default GeneralTab;